<template>
	<div>
		<v-dialog
			:value="true"
			max-width="400"
			@click:outside="handleClose"
			@keydown.esc="handleClose"
		>
			<v-card>
				<ValidationObserver ref="form" tag="form" @submit="handleSubmit">
					<v-container>
						<v-row>
							<v-col>
								<ValidationProvider rules="required" v-slot="{ errors }">
									<v-text-field
										v-model="departmentEditable.name"
										outlined
										:label="$t('label.name')"
										:error-messages="errors"
										hide-details
										dense
									></v-text-field>
								</ValidationProvider>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<ValidationProvider rules="required" v-slot="{ errors }">
									<v-select
										v-model="departmentEditable.organization_id"
										:items="organizations"
										item-text="name"
										item-value="id"
										:label="$t('label.department')"
										outlined
										:error-messages="errors"
										hide-details
										dense
									></v-select>
								</ValidationProvider>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<fieldset
									class="talentics-fieldset talentics-fieldset-paddings"
								>
									<legend>
										{{ $t('label.status') }}:
										{{
											departmentEditable.active
												? $t('label.active')
												: $t('label.inactive')
										}}
									</legend>
									<v-switch
										v-model="departmentEditable.active"
										color="success"
										inset
										hide-details
										dense
										class="v-input--template-switch"
									></v-switch>
								</fieldset>
							</v-col>
						</v-row>
					</v-container>
				</ValidationObserver>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="handleClose">{{
						$t('button.close')
					}}</v-btn>
					<v-btn
						color="error"
						outlined
						@click="hanleDeleteClick"
						v-if="method === 'edit'"
						>{{ $t('button.delete') }}</v-btn
					>
					<v-btn color="primary" @click="handleSubmit">{{
						$t('button.save')
					}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<Confirm
			v-if="isDeleteConfirmVisible"
			:onConfirm="handleConfirmDialogConfirm"
			:onClose="handleConfirmDialogClose"
			primaryActionColor="error"
			><div style="padding-top: 20px">
				{{ $t('text.confirm-deleting-department') }}
			</div></Confirm
		>
	</div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Confirm from '@/components/shared/dialogs/confirm/Confirm';
import { mapState } from 'vuex';

export default {
	name: 'DepartmentAttrs',
	components: {
		ValidationObserver,
		ValidationProvider,
		Confirm,
	},
	computed: {
		...mapState({
			organizations: state => state.organizations.items,
		}),
	},
	props: {
		method: {
			type: String,
			required: true,
		},
		department: {
			type: Object,
			required: false,
			default() {
				return {
					active: true,
					name: '',
					organization_id: null,
				};
			},
		},
		onClose: {
			type: Function,
			required: true,
		},
	},
	data() {
		const { department } = this;
		return {
			departmentEditable: JSON.parse(JSON.stringify(department)),
			isDeleteConfirmVisible: false,
		};
	},
	methods: {
		handleClose() {
			this.onClose();
		},
		async handleSubmit(evt) {
			if (evt) {
				evt.preventDefault();
			}
			const isValid = await this.$refs.form.validate();
			if (isValid) {
				const { departmentEditable, method } = this;
				if (method === 'edit') {
					this.$store
						.dispatch('departments/put', {
							items: [{ ...departmentEditable }],
						})
						.then(() => {
							this.handleClose();
						});
				} else if (method === 'add') {
					this.$store
						.dispatch('departments/post', {
							items: [{ ...departmentEditable }],
						})
						.then(() => {
							this.handleClose();
						});
				}
			}
		},
		handleConfirmDialogConfirm() {
			const { id } = this.departmentEditable;
			this.$store.dispatch('departments/delete', { id }).then(() => {
				this.handleClose();
			});
		},
		handleConfirmDialogClose() {
			this.isDeleteConfirmVisible = false;
		},
		hanleDeleteClick() {
			this.isDeleteConfirmVisible = true;
		},
	},
	watch: {
		department(newVal) {
			this.departmentEditable = { ...newVal };
		},
	},
};
</script>
